import React from 'react'
import TCs from '../fetures/t&c/TCs'

const TCsPage = () => {
  return (
    <TCs/>
  )
}

export default TCsPage